import React, { FC, useCallback, useEffect, useState } from 'react';
import { HomeSearch, HomeSearchProps } from './home-search';
import { useHistory } from 'react-router-dom';
import { useServicesFilters } from '../../hooks/use-services-filters';
import { useHomeBanners } from '../../hooks/use-home-banners';
import { useSearchSuggestionsByTitle } from './hooks';

const STANDARD_BANNER = {
  url: `${process.env.PUBLIC_URL}/images/banner/standard-banner.jpg`,
  description:
    'Vista panorâmica de Olinda a partir do mirante, com casas históricas de telhados coloniais, igreja entre as árvores e litoral ao fundo.',
};
const NUMBER_OF_SUGGESTIONS = 3;

export const HomeSearchContainer: FC = (isMediumScreen) => {
  const { setFilters } = useServicesFilters();
  const history = useHistory();
  const { data: banners } = useHomeBanners();
  const [currentImage, setCurrentImage] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState(searchInputValue);

  const onClickSearch = useCallback(
    (value: string) => {
      setFilters((prev: any) => ({ ...prev, searchQuery: value }));
      if (!value) return;
      history.push(`search/${value}`);
    },
    [history, setFilters]
  );

  const onClickSearchSuggestion = useCallback(
    (value: string) => {
      if (!value) return;
      history.push(`carta-de-servicos/${value}`);
    },
    [history]
  );

  const { data: suggestions = [] } = useSearchSuggestionsByTitle({
    value: debouncedValue,
    limit: NUMBER_OF_SUGGESTIONS,
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(searchInputValue);
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchInputValue]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % (banners?.length ?? 1));
    }, 5000);

    return () => clearInterval(interval);
  }, [banners]);

  const props: HomeSearchProps = {
    onClickSearch,
    images: banners && banners.length > 0 ? banners : [STANDARD_BANNER],
    currentImage: banners && banners.length > 0 ? banners[currentImage] : STANDARD_BANNER,
    searchInputValue: searchInputValue,
    setSearchInputValue: setSearchInputValue,
    suggestions: debouncedValue.length >= 2 ? suggestions : [],
    onClickSearchSuggestion,
  };

  return <HomeSearch {...props} />;
};
